module.exports = __webpack_public_path__ + "static/media/logo_black_1024.2a925697.png";